export default {
  methods: {
    calculateTotal(array, prop) {
      return this.$worker.run((array, prop) => {
        var total = 0;
        for (var row of array) {
          if (!!row[prop]) {
            var number = Number(row[prop]);
            total += number;
          }
        }
        return total;
      }, [array, prop])
    }
  },
}